import classNames from "classnames";
import { useState } from "react";

const ColorSwatches = ({ swatches }: any) => {
  const [active, setActive] = useState<any>(0);
  return (
    <div className="flex flex-wrap gap-6 items-start justify-start">
      <div className="w-[200px]">
        <img
          src={swatches[active].src}
          alt=""
          className="max-w-[200px] max-h-[200px]"
        />
      </div>
      <div className="w-[calc(100%-300px)] flex flex-wrap gap-2 items-start justify-start">
        {swatches.map((item: any, index: any) => (
          <div
            key={index}
            className={classNames(
              "text-center text-[8px] leading-[9px] w-[50px]"
            )}
          >
            <div
              className={classNames(
                "border p-[2px] rounded-[5px] w-[50px] h-[50px] cursor-pointer hover:border-[#4CC66E]",
                {
                  "border-[#e5e5e5]": index !== active,
                  "border-[#4CC66E]": index === active,
                }
              )}
              onClick={() => setActive(index)}
            >
              <img src={item.src} alt="" />
            </div>
            {/* <div className="px-2 mt-1 w-[50px]">{item.name}</div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColorSwatches;
